// Подпись машины в выпадающих списках: «КОД - НОМЕР».
//
// Дефис в этих списках был безусловным, поэтому у машины без госномера подпись
// заканчивалась висячим «-» («E2E-001 -»). Номера не бывает у технической машины,
// у только что заведённой и у любой ещё не поставленной на учёт — то есть это
// нормальное состояние, а не пропуск данных, и разделителю в этом случае нечего
// разделять.
export function carLabel(car) {
  if (!car) return "";
  const code = car.code == null ? "" : String(car.code).trim();
  const number = car.number == null ? "" : String(car.number).trim();
  if (code && number) return `${code} - ${number}`;
  return code || number;
}
